import { useMemo } from 'react';

import { INewbuilding } from '../../../types/newbuilding';

export function useChatButtonContextValue({ builders, sellers }: INewbuilding) {
  return useMemo(
    () => ({
      builders,
      sellers,
    }),
    [builders, sellers],
  );
}
